module.exports = __webpack_public_path__ + "static/media/horoscope-icon-7.8811b694.png";


//////////////////
// WEBPACK FOOTER
// ./src/checkastronow/assets/images/horoscopes/horoscope-icon-7.png
// module id = 1533
// module chunks = 0